import React from 'react';

import HorizontalScroller from 'components/uiLibrary/HorizontalScroller';
import { TextButton } from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Typography from 'components/uiLibrary/Typography';

import { COMPONENTS } from 'components/Globals/Analytics/constants';
import { usePaywallContext } from 'components/Paywall';

import { SORT_OPTION_VALUES, TP } from 'constants/index';

import useAppContext from 'utils/hooks/useAppContext';
import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';
import { useDialogs } from 'utils/hooks/useDialogs';
import { useQuery } from 'utils/react-query';

import queries from 'containers/Organizations/queries';

import { useTranslation } from 'src/i18n';

import classes from './TrustedBy.module.scss';

const ViewAll = ({ trackingData }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const { isLoggedIn } = useAppContext();
  const { setShowSubscriptionPlans } = usePaywallContext();
  const { setIsLoginDialog } = useDialogs();

  const handleViewAll = () => {
    if (isLoggedIn) {
      setShowSubscriptionPlans({
        show: true,
      });
    } else {
      setIsLoginDialog({ isOpen: true });
    }
  };

  return (
    <TextButton
      rightIcon={<SpriteIcon icon="chevron_right" size={12} className={classes.arrowIcon} />}
      styles={{ root: classes.viewAllBtn }}
      disableUnderline
      onClick={handleViewAll}
      trackingData={{
        ...trackingData,
        component: COMPONENTS.VIEW_ALL_CUSTOMERS_AND_TESTIMONIALS,
      }}
    >
      <Typography size={12} className={classes.viewAllBtnText}>
        {t(`${TP}.VIEW_COMPLETE_LIST_CTA`)}
      </Typography>
    </TextButton>
  );
};

const TrustedBy = ({ limit = 6, trackingData }) => {
  const { isDesktop } = useDeviceTypeLayouts();
  const { t } = useTranslation('NS_APP_GLOBALS');

  const { data: organizations } = useQuery(
    queries.getOrganizations({
      limit,
      filters: {
        sort: SORT_OPTION_VALUES.PRODUCTION_COUNT_DESC,
        is_pro: true,
      },
      queryConfig: {
        select: response => response?.data.map(org => org.name),
      },
    }),
  );

  if (!isDesktop) {
    return (
      <>
        <HorizontalScroller hideArrow>
          <div className={classes.trustedBy}>
            <Typography color="white" size={12} secondaryFont className={classes.title}>
              {t('FN_TRUSTED_BY_TITLE')}
            </Typography>
            <div className={classes.trustedByItems}>
              {organizations?.map(orgName => (
                <Typography color="white" size={12} key={orgName} className={classes.orgName}>
                  {orgName}
                </Typography>
              ))}
            </div>
          </div>
        </HorizontalScroller>
        <ViewAll trackingData={trackingData} />
      </>
    );
  }

  return (
    <HorizontalScroller hideArrow>
      <div className={classes.trustedBy}>
        <Typography color="white" size={12} secondaryFont className={classes.title}>
          {t('FN_TRUSTED_BY_TITLE')}
        </Typography>
        <div className={classes.trustedByItems}>
          {organizations?.map(orgName => (
            <Typography color="white" size={12} key={orgName} className={classes.orgName}>
              {orgName}
            </Typography>
          ))}
          <ViewAll trackingData={trackingData} />
        </div>
      </div>
    </HorizontalScroller>
  );
};

export default TrustedBy;
